module.exports = __webpack_public_path__ + "media/img/logo-transparent-sm-bare-30e2f18d9b52adb43f837af03083f190.png";